import videoProviders from '../../fieldOptions/videoProviders'
import zoomTypes from '../../fieldOptions/zoomTypes'
import DateToggle from '../date-toggle'
import slugify from '../../slugify'
import TagSelector from '../institutions/tag-selector'

export default [
  {
    name: 'Title',
    prop: 'title',
    type: 'text'
  },
  {
    name: 'URL',
    prop: 'slug',
    type: 'text',
    filter: slugify
  },
  {
    name: 'Start',
    prop: 'start_at',
    type: 'datetime',
    onChange: (value, resource) => {
      if (!resource.end_at) {
        resource.end_at = value
      }
    }
  },
  {
    name: 'End',
    prop: 'end_at',
    type: 'datetime'
  },
  {
    name: 'Video URL',
    prop: 'video_url',
    type: 'text',
    onChange: (value, resource) => {
      if (!resource.video_provider) {
        if (/youtube/.test(value)) {
          resource.video_provider = 'youtube'
        } else if (/vimeo/.test(value)) {
          resource.video_provider = 'vimeo'
        }
      }
    }
  },
  {
    name: 'Video Provider',
    prop: 'video_provider',
    type: 'select',
    isClearable: true,
    options: videoProviders
  },
  {
    name: 'Facilitator',
    prop: 'facilitator_id',
    type: 'autocomplete',
    references: 'admin/users',
    referenceProp: 'fullname',
    displayProp: 'name',
    query: {
      filters: {
        roles_json_contains: 'facilitator'
      }
    },
    showIf: resource => resource.type !== 'course'
  },
  {
    name: 'Category',
    prop: 'category_id',
    type: 'autocomplete',
    references: 'admin/categories',
    customFilters: { type: 'webinar' },
    referenceProp: 'name'
  },
  {
    name: 'Description',
    prop: 'description',
    type: 'wysiwyg'
  },
  {
    name: 'Resources',
    prop: 'resources',
    type: 'wysiwyg'
  },
  { name: 'Meta Title', prop: 'meta_title', type: 'text' },
  { name: 'Meta Keywords', prop: 'meta_keywords', type: 'text' },
  { name: 'Meta Description', prop: 'meta_description', type: 'text' },
  { name: 'Meta Image', prop: 'meta_image', type: 'text' },
  {
    name: 'Chat Disabled',
    prop: 'chat_disabled',
    type: 'checkbox'
  },
  {
    name: 'Members Only',
    prop: 'requires_membership',
    type: 'checkbox'
  },
  {
    name: 'External Event',
    prop: 'is_external',
    type: 'checkbox',
    onChange: (isChecked, resource) => {
      if (!isChecked) resource.external_url = null
    }
  },
  {
    name: 'External Event URL',
    prop: 'external_url',
    type: 'text',
    showIf: resource => !!resource.is_external,
    helperText: 'Where "View Details" sends members before the event ends — e.g. https://community.ncfdd.org/c/events/...'
  },
  {
    name: 'Zoom Type',
    prop: 'zoom_type',
    type: 'select',
    isClearable: true,
    options: zoomTypes,
    onChange: (value, resource) => {
      if (!value) {
        resource.zoom_id = null
        resource.zoom_join_url = null
      }
    }
  },
  {
    name: 'Zoom Meeting/Webinar ID',
    prop: 'zoom_id',
    type: 'text',
    showIf: resource => !!resource.zoom_type,
    helperText: 'Must have registration ON, approval set to "Automatically Approve", and an auto-generated ID (not a Personal Meeting ID) — otherwise join links will not work. The event must be scheduled under the Zoom user holding the matching license.'
  },
  {
    name: 'Zoom Join URL (fallback)',
    prop: 'zoom_join_url',
    type: 'text',
    showIf: resource => !!resource.zoom_type,
    helperText: 'General join link, used if a member\'s unique link could not be generated.'
  },
  {
    name: 'Tags',
    prop: 'tags',
    type: 'component',
    component: TagSelector
  },
  {
    name: 'Published',
    prop: 'published_at',
    type: 'component',
    component: DateToggle
  }
]
